import React from 'react';
import moment from 'moment';
import { PagoRequest } from '../../../models/Pago';
import Input from '../../Forms/Input';
import { formatCurrencyStyled } from '../../visuals/currency.formatted';
import PagosExternalBill from './Pagos.externalBill';
import { ArgumentBinded } from '../handlers/pago.state';

interface PagosRelacionadasProps {
    cfdi: PagoRequest;
    bindersSelected: ArgumentBinded[];
    externalBill: boolean;
    displayNoRfcWarning: boolean;
    // Emitters
    onMontoPaidChange: (index: number) => (value: number) => void;
    onAddRelated: () => void;
}

function PagosRelacionadas({ cfdi, bindersSelected, externalBill, displayNoRfcWarning, onMontoPaidChange, onAddRelated }: PagosRelacionadasProps) {
    return (
        <div>
            <h4>Facturas relacionadas</h4>
            <div className="card table">
                <div className="cardBody facturasTable">
                    {
                        !bindersSelected.length ?
                            (!externalBill ? '' :
                                <PagosExternalBill display={externalBill} />
                            )

                            :
                            <div className="card table">
                                <div className="cardTitle">
                                    <div className="_relatedBillHeader _relatedBill">
                                        <p className="date">Fecha de factura</p>
                                        <p className="serieFolio">Serie <br /> Folio</p>

                                        <p className="rfc">RFC</p>
                                        <p className="parcialidad">Parcialidad</p>
                                        <p>Monto Pagado</p>
                                        <p className="pendiente">Quedaría pendiente</p>
                                    </div>
                                </div>
                                <div className="cardBody">
                                    <div className="relatedWrap">
                                        {
                                            bindersSelected.map((binder, i) => {
                                                const doctoRel = cfdi.pagos[0].facturaRelacionada[i];
                                                if (!doctoRel) {
                                                    return (
                                                        <div key={i} className="_relatedBill" />
                                                    )
                                                }
                                                return (
                                                    <div key={i} className="_relatedBill">
                                                        <p className="date">{moment(new Date(binder.cfdi.json["@"].Fecha).getTime()).format('DD/MMM/YYYY')}</p>
                                                        <div className="row serie">
                                                            <p>Serie: {binder.cfdi.json["@"].Serie}</p>
                                                            <p className="small">Folio: {binder.cfdi.json["@"].Folio}</p>
                                                        </div>
                                                        <p className="rfc">{binder.cfdi.json["cfdi:Receptor"]["@"].Rfc}</p>
                                                        <div className="row parcialidad">
                                                            <p>{doctoRel.numParcialidad} de {binder.argument.paymentEvents.length}</p>
                                                            <p className="small">Esperado: {formatCurrencyStyled(cfdi.pagos[0].monto)}</p>
                                                        </div>
                                                        <Input type="number" step={0.01} isCurrency={true} label={`Pagado`} value={doctoRel.importePagado} onChange={onMontoPaidChange(i)} max={binder.insoluto} />
                                                        <div className="remainder">
                                                            <p>{formatCurrencyStyled(binder.insoluto - doctoRel.importePagado)}</p>
                                                            <p className="_from">de {formatCurrencyStyled(binder.insoluto)}</p>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                    }
                    <div className="_action">
                        <div className="addBill" onClick={onAddRelated}>
                            <i className="material-icons">add_circle</i>
                            <span>Agregar {cfdi.pagos[0].facturaRelacionada.length > 0 ? 'otra Factura Relacionada' : 'una Factura Relacionada'} </span>
                            {
                                displayNoRfcWarning ?
                                    <div className='noRfc'>
                                        <span>Agregue receptor primero</span>
                                    </div>
                                    : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PagosRelacionadas;
